import React from 'react';

// material components
import Autocomplete from "@material-ui/lab/Autocomplete";
import { IconButton, TextField, Tooltip } from '@material-ui/core';
import { KeyboardDatePicker } from "@material-ui/pickers";
import Button from "@material-ui/core/Button";
import green from "@material-ui/core/colors/green";
import { Popper } from '@mui/material';
import Divider from "@material-ui/core/Divider";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';

// custom components
import CommentHistoryTable from "../global/CommentHistoryTable";


// constants
import {
    COMPLETED_STATUS,
    SAVE,
    CANCEL,
    ACTIONS,
    ADD_ACTION,
    TASKS_CHECKBOXES_HEADER,
    ADD_ACTION_BUTTON_TEXT,
    WRONG_ITEM_ORDERED_SHORTCODE_LABEL,
    WRONG_ITEM_ORDERED_QUANTITY_LABEL,
    WRONG_ITEM_SENT_QUANTITY_LABEL,
    WRONG_ITEM_SENT_SHORTCODE_LABEL, ACTION_LABEL, TICKETS_TOOLBAR_TITLE, BACK_TO_MENU, REFUND_TYPES, REFUND_DETAIL_MAP, REFUND_DETAIL_TAX_MAP
} from './constants';

// styling
import './TicketsForm.css';
import { REFUND_AMOUNT_CHECKBOX } from "../returns/constants";
import InputAdornment from "@material-ui/core/InputAdornment";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import FileUpload from "../global/FileUpload";
import { getByteArray } from "../global/constants";
import PropTypes from "prop-types";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Label_printedIcon from '../../media/images/Label_printed.png';
import PickedIcon from '../../media/images/Picked-up.png';
import InTransitIcon from '../../media/images/In-Transit.png';
import DeliveredIcon from '../../media/images/Delivered.png';
import ExceptionIcon from '../../media/images/Exception.png';
import UnshippedIcon from '../../media/images/Unshipped.png';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DownloadIcon from '@mui/icons-material/Download';
import { Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Typography from '@material-ui/core/Typography';
import RefundPopper from './RefundPopper';
import TopToolbar from '../global/subcomponents/topToolbar/TopToolbar';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import _ from 'lodash';
import InfoIcon from "@material-ui/icons/Info";


class TicketsForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            originalTrackingId: this.getValue('originalTrackingId'),
            orderId: this.getValue('orderId'),
            actions: this.getValue('actions'),
            customerName: this.getValue('customerName'),
            assignedToId: this.getValue('assignedToId'),
            assignedToName: this.getValue('assignedToName'),
            dueDate: this.getValue('dueDate'),
            comments: this.getValue('comments'),
            ticketIssueId: this.getValue('ticketIssueId'),
            ticketId: this.getValue('ticketId'),
            ticketIssueName: this.getValue('ticketIssueName'),
            wrongShortcodeSent: this.getValue('wrongShortcodeSent'),
            wrongQuantitySent: this.getValue('wrongQuantitySent'),
            wrongShortcodeOrdered: this.getValue('wrongShortcodeOrdered'),
            wrongQuantityOrdered: this.getValue('wrongQuantityOrdered'),
            files: this.getValue('files'),
            location: this.getValue('location'),
            shipAddressId: this.getValue('shipAddressId'),
            pdfFile: null,
            newFiles: [],
            deletedFiles: [],
            validate: false,
            isDialogOpen: false,
            isBackDialogOpen: false,
            type: null,
            action:null ,
            index: null,
            fileIndex: null,
            file: null,
            enableSave: true,
            tempActions:  null,
            isMPS: false,
            showPopper: false,
            anchorEl: null,
            whitelist: {
                anchorEl: true,
                showPopper: true,
                isMPS: true,
                isBackDialogOpen: true,
                type: true,
                action: true,
                index: true,
                fileIndex: true,
                file: true,
                isDialogOpen: true,
                'validate': true,
                'tempActions': true,
                'actions': true,
                'files': true,
                'newFiles': true,
                'deletedFiles': true,
                'comments': true,
                'ticketId': true,
                'enableSave': true,
                'pdfFile': true
            },
            requiredListWrongItemSent: {
                'wrongShortcodeSent': true,
                'wrongQuantitySent': true,
            },
            requiredListWrongItemOrdered: {
                'wrongShortcodeOrdered': true,
                'wrongQuantityOrdered': true,
            }
        }
        this.baseState = this.state
        this.baseActions = _.cloneDeep(this.state.actions);
    }

    componentDidMount() {
        if (!this.props.creatingTicket) {
            this.props.requestIssueSpecificActions({ ticketIssueId: this.props.ticket.ticketIssueId })
            this.props.requestIssueSpecificTasks({ ticketIssueId: this.props.ticket.ticketIssueId })
        }

        if (this.props.ticket?.actions) {
            this.baseActions = _.cloneDeep(this.props.ticket.actions);
            this.setState({ tempActions: this.props.ticket?.actions });
        }

        const hasReturnOrRedirectLabel = Array.isArray(this.state.actions) &&
            this.state.actions.some(
                a => a?.actionName === 'Send Return Label' || a?.actionName === 'Send Redirect Label'
            );

        if (hasReturnOrRedirectLabel) {
            this.props.returnRedirectTrackingStatus({
                ticketId: this.props.ticket.ticketId,
                actions: this.state.actions,
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // if the file preview has been fetched
        if (this.props !== prevProps && this.props.ticket) {
            this.setState({
                files: this.props.ticket.files // TODO account for nested attachments
            })
        }

        if (this.props.returnRedirectData !== prevProps.returnRedirectData) {
            const { returnTrackingNumber, rate, rateCurrency, pdfByte, labelFor, redirectLabelId, actionIndex } = this.props.returnRedirectData;
            const pdfBlob = new Blob([new Uint8Array(pdfByte)], { type: 'application/pdf' });
            if(labelFor === "Return"){
                // Convert `pdfByte` to a Blob and create a File object
                const pdfFile = new File([pdfBlob], `${this.state.orderId}-${returnTrackingNumber}.pdf`, { type: 'application/pdf' });

                // Add the formatted file to the action using `handleFileAdd`
                const action = this.state.actions[actionIndex]; // Assuming you're adding to the first action

                const formattedFile = this.getFormattedFileObject(action, pdfFile);
                this.handleFileAdd(action, actionIndex, pdfFile);

                // Update state for return rate and tracking number
                this.setState(
                    prevState => ({
                        actions: prevState.actions.map((action, index) =>
                            index === actionIndex
                                ? {
                                    ...action,
                                    returnTrackingId: returnTrackingNumber,
                                    returnRate: rate,
                                    returnRateCurrency: rateCurrency
                                }
                                : action
                        ),
                    }),
                    () => {
                        this.props.returnRedirectTrackingStatus({
                            ticketId: this.props.ticket.ticketId,
                            actions: this.state.actions,
                        });
                    }
                );
            }
           /* else{
                // Convert `pdfByte` to a Blob and create a File object
                const pdfFile = new File([pdfBlob], `Redirect Label-${redirectLabelId}.pdf`, { type: 'application/pdf' });

                // Add the formatted file to the action using `handleFileAdd`
                const action = this.state.actions[actionIndex]; // Assuming you're adding to the first action

                const formattedFile = this.getFormattedFileObject(action, pdfFile);
                this.handleFileAdd(action, actionIndex, pdfFile);

                // Update state for return rate and tracking number
                this.setState(
                    prevState => ({
                        actions: prevState.actions.map((action, index) =>
                            index === actionIndex
                                ? {
                                    ...action,
                                    redirectLabelId: redirectLabelId,
                                    returnRate: rate,
                                    returnRateCurrency: rateCurrency
                                }
                                : action
                        ),
                    }),
                    () => {
                        this.props.returnRedirectTrackingStatus({
                            ticketId: this.props.ticket.ticketId,
                            actions: this.state.actions,
                        });
                    }
                );
            }*/
        }

        if(this.props.orderInfoFetch !== prevProps.orderInfoFetch) {
            this.setState({originalTrackingId: this.props.orderInfoFetch?.trackingNumber,
            isMPS:this.props.orderInfoFetch?.isMPS})
            if(this.props.orderInfoFetch?.customerNameAndOrderItems[0]?.shippingAddressName?.length > 1){
                this.setState({
                    customerName: this.props.orderInfoFetch?.customerNameAndOrderItems[0]?.shippingAddressName,
                    orderId: this.props.orderInfoFetch?.customerNameAndOrderItems[0]?.orderItems[0]?.orderId,
                })
            }
        }

        if(this.state.ticketIssueName !== prevState.ticketIssueName) {
            this.props.requestIssueSpecificActions({ ticketIssueId: this.state.ticketIssueId })
            this.props.requestIssueSpecificTasks({ ticketIssueId: this.state.ticketIssueId })
            this.setState({
                wrongShortcodeSent: "",
                wrongQuantitySent: "",
                wrongShortcodeOrdered:"",
                wrongQuantityOrdered:""
            })
        }

        if (this.props.refundAmount !== prevProps.refundAmount && Object.keys(this.props.refundAmount).length > 0) {
            this.setState((prevState) => ({
                actions: prevState.actions.map((action, index) => {
                    if (action.actionName !== "Issue Refund") {
                        return action;
                    }

                    const rawRefundAmount = this.props.refundAmount
                        ? this.props.refundAmount[index]
                        : null;

                    if (rawRefundAmount == null) {
                        return {
                            ...action
                        };
                    }

                    const formattedRefundAmount = Number(rawRefundAmount).toFixed(2);

                    return {
                        ...action,
                        refundAmount: formattedRefundAmount,
                    };
                }),
            }));
        }

        if (this.props.refundDetails !== prevProps.refundDetails && this.props.refundDetails && Object.keys(this.props.refundDetails).length > 0) {
            this.setState((prevState) => ({
                actions: prevState.actions.map((action, index) => {
                    if (action.actionName !== "Issue Refund") {
                        return action;
                    }

                    const detail = this.props.refundDetails[index];

                    if (!detail) {
                        return { ...action };
                    }

                    const normalizedDetails = Object.fromEntries(
                        Object.entries(detail).map(([key, value]) => {
                            if (value === null || value === undefined) {
                                return [key, value];
                            }
                            if (isNaN(Number(value))) {
                                return [key, value];
                            }

                            return [key, Number(value).toFixed(2)];
                        })
                    );

                    return {
                        ...action,
                        refundDetails: normalizedDetails,
                    };
                }),
            }));
        }
    }

    handleDateChange = (date) => {
        this.setState({
            dueDate: date
        })
    }


    getValue = (key) => {

        if(!this.props.creatingTicket && key === 'orderId'){
          this.props.fetchOrderInfo({ orderId: this.props.ticket[key] });
        }

        if (this.props.creatingTicket && key === 'dueDate') {
            const today = new Date()
            const tomorrow = new Date(today)
            tomorrow.setDate(tomorrow.getDate() + 1)
            return tomorrow
        }

        if (key === 'files' && !this.props.creatingTicket)
            return this.props.ticket[key]
        else if (key === 'files')
            return []
        let location = this.props.locations.find(location => location["shipAddressId"] === this.props.currentUser.selectedLocationId)
        if (key === 'location') return location
        if (key === 'shipAddressId') return location.shipAddressId
        if (this.props.creatingTicket || key === 'comments')
            return ''

        return this.props.ticket[key]
    }

    handleIssueChange = (value) => {
        this.setState({
            ticketIssueId: value.ticketIssueId,
            ticketIssueName: value.ticketIssueName
        });

    }

    handleLocationChange = (value) => {
        this.setState({
            location: value,
            shipAddressId: value.shipAddressId
        })
    }

    handleAutocompleteChange = async (value, name, index) => {
        if(index === -1) {
            this.setState({
                [name]: value
            })
        }
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleOrderIdChange = (e) => {
        this.trimField(e)
        if (e.target.value.trim() !== "") {
            this.props.fetchOrderInfo({ orderId: this.state.orderId })
        }
    }
    handleOriginalTrackingIdChange = (e) => {
        this.trimField(e)
        if (e.target.value.trim() !== "") {
            this.props.fetchOrderInfo({ originalTrackingId: this.state.originalTrackingId })
        }
    }

    trimField = (e) => {
        this.setState({
            [e.target.name]: e.target.value.trim()
        })
    }

    getRefundOption = () => {
        let options = [REFUND_TYPES.FULL_REFUND, REFUND_TYPES.DEDUCT_RESTOCKING_FEE_ONLY]

        const returnRedirectActions = this.state.actions?.filter(
            a => a?.actionName === "Send Return Label" || a?.actionName === "Send Redirect Label"
        ) || [];

        if(returnRedirectActions && returnRedirectActions.length > 0){
            if (returnRedirectActions.length > 1) {
                return [];
            }

            const returnRedirectAction = returnRedirectActions[0];
            if(returnRedirectAction.actionName === "Send Return Label"){
                if (returnRedirectAction.returnTrackingId) {
                    options.push(REFUND_TYPES.DEDUCT_RESTOCKING_FEE_AND_RETURN_COST)
                }
            }
            else if(returnRedirectAction.actionName === "Send Redirect Label"){
                if (returnRedirectAction?.redirectLabelId) {
                    options.push(REFUND_TYPES.REDIRECT_REFUND)
                }
            }
        }

        return options
    }

    allowRefundCalculation = () => {
        if (this.state.isMPS){
            return false
        }
        if (this.state.ticketIssueName === 'Wrong Item Sent' &&
            (!this.state.wrongShortcodeSent || !this.state.wrongShortcodeSent)){
            return false
        }
        if (this.state.ticketIssueName === 'Wrong Item Ordered' &&
            (!this.state.wrongShortcodeOrdered || !this.state.wrongQuantityOrdered)){
            return false
        }

        // validate return /redirect action, only support refund calculation with 1 return/ redirect label
        const returnRedirectActions = this.state.actions?.filter(
            a => a?.actionName === "Send Return Label" || a?.actionName === "Send Redirect Label"
        ) || [];

        if(returnRedirectActions && returnRedirectActions.length > 0){
            if (returnRedirectActions.length > 1) {
                return false;
            }

            const returnRedirectAction = returnRedirectActions[0];
            if(returnRedirectAction.actionName === "Send Return Label"){
                if (!returnRedirectAction?.returnTrackingId) {
                    return false;
                }
            }
            if(returnRedirectAction.actionName === "Send Redirect Label"){
                if (!returnRedirectAction?.redirectLabelId) {
                    return false;
                }
            }
        }

        // only allow 1 action on refund calculation
        const issueRefundActions = this.state.actions?.filter(
            a => a?.actionName === 'Issue Refund'
        ) || [];

        if(issueRefundActions && issueRefundActions.length > 1){
            return false
        }


        return true
    }

    calculateRefund = (action, index) => {
        const updatedActions = [...this.state.actions];
        updatedActions[index].refundAmount = '';
        const { refundDetails, ...rest } = updatedActions[index];
        updatedActions[index] = rest;
        this.setState({ actions: updatedActions });
        this.props.clearTicketRefundAmount(index)

        const refundType = action?.refundType? action.refundType : "";

        const data = {
            type: refundType,
            originalTrackingId: this.state.originalTrackingId,
            orderId: this.state.orderId
        };
        if( this.state.ticketIssueName === 'Wrong Item Ordered'){
            data.shortcode =  this.state.wrongShortcodeOrdered
            data.quantity =  this.state.wrongQuantityOrdered
        }
        else if (this.state.ticketIssueName === "Wrong Item Sent" || this.state.ticketIssueName === "Wrong Quantity Sent"){
            data.shortcode =  this.state.wrongShortcodeSent
            data.quantity =  this.state.wrongQuantitySent
        }

        const returnRedirectActions = this.state.actions?.filter(
            a => a?.actionName === "Send Return Label" || a?.actionName === "Send Redirect Label"
        ) || [];

        if(returnRedirectActions && returnRedirectActions.length > 0){
            if (returnRedirectActions.length > 1) {
                return;
            }

            const returnRedirectAction = returnRedirectActions[0];
            if(returnRedirectAction.actionName === "Send Return Label"){
                if (returnRedirectAction.returnTrackingId) {
                    data.returnTrackingId = returnRedirectAction.returnTrackingId
                }
            }
            else if(returnRedirectAction.actionName === "Send Redirect Label"){
                if (returnRedirectAction?.redirectLabelId) {
                   data.redirectLabelId = returnRedirectAction.redirectLabelId
                }
            }
        }

        this.props.calculateTicketRefundAmount(index, data);

        this.handlePopupClose();
    };

    handlePopupOpen = (event) => {
        this.setState({
            showPopper: true,
            anchorEl: event.currentTarget,
        });
    };

    handlePopupClose = () => {
        this.setState({ showPopper: false, anchorEl: null, }); // Close the popper
    }

    handleRefundTypeChange = (action, index) => (event) => {
        const updatedActions = [...this.state.actions];
        updatedActions[index].refundType = event;
        this.setState({ actions: updatedActions },()=>{
            this.calculateRefund(action, index)
        });
    };

    addAction = () => {
        const { actions } = this.state;
        actions.push({})
        this.setState({
            actions: actions
        })
    }
    removeAction = (index) => {
        const { actions } = this.state;
        let actionName = actions[index]?.actionName
        actions.splice(index, 1)
        this.setState({
            actions: actions
        })
        if(actionName === 'Issue Refund'){
            this.props.clearTicketRefundAmount(index)
        }
    }

    handleCommentUpdate = (e) => {
        this.setState({
            comments: {
                user: this.props.currentUser.firstname + " " + this.props.currentUser.lastname,
                date: new Date().toISOString(),
                comment: e.target.value
            }
        })
    }

    handleActionChange = (newAction, index) => {

        const { actions } = this.state;
        let taskItems = this.props.ticketActionTasks[this.state.ticketIssueName].ticketIssueTasks.find((task) => task.ticketActionName === newAction.ticketActionName)


        actions[index] = {
            actionName: newAction.ticketActionName,
            actionId: newAction.ticketActionId,
            tasks: taskItems,
            files: [],
            newFiles: [],
            deletedFiles: [],
            redirectLabelId: '',
            returnTrackingId:''
        }

        this.setState({
            actions: actions
        });
    }

    handleActionValueChange = (e, index) => {
        const {name, value} = e.target
        const { actions } = this.state
        actions[index][name] = value
        if (name === "refundAmount") {
            const { refundDetails, ...rest } = actions[index];
            actions[index] = rest;
        }
        this.setState({
            actions: actions
        },()=>{

            if(name === "refundAmount"){
                this.props.clearTicketRefundAmount(index)
            }
        })
    }

  handleReturnTrackingNumberBlur = (e, index) => {
        if(e.target.value){
            const { ticket } = this.props;
            this.props.returnRedirectTrackingStatus({
                ticketId: ticket.ticketId,
                actions: this.state.actions,
            });
        }
        else if (this.state.actions.length > index && this.props.trackingStatusAndRate){
            this.props.clearReturnRedirectTrackingNumber(index)
        }
    };


    handleActionTaskUpdate = (e, index, taskIndex) => {
        const { actions } = this.state
        let curStatus = actions[index].tasks.ticketActionTasks[taskIndex].taskStatus
        actions[index].tasks.ticketActionTasks[taskIndex].taskStatus = !curStatus
        this.setState({
            actions: actions
        })

    }

    getTaskFields = (action, index) => {
        if (action?.tasks?.ticketActionTasks?.length > 1) {
            //Force a certain order for actions with 3 checkboxes
            let newTickerActionTasks = []
            newTickerActionTasks = [...newTickerActionTasks, action.tasks.ticketActionTasks.find(task => task.ticketActionTaskName.includes('label'))]
            newTickerActionTasks = [...newTickerActionTasks, action.tasks.ticketActionTasks.find(task => task.ticketActionTaskName.includes('shipped'))]
            newTickerActionTasks = [...newTickerActionTasks, action.tasks.ticketActionTasks.find(task => task.ticketActionTaskName.includes('received'))]
            action.tasks.ticketActionTasks = newTickerActionTasks
        }
        return (
            <div className='ticket-text-field'>
                <FormControl component="fieldset">
                    <FormGroup>
                        {action?.tasks?.ticketActionTasks?.map((task, j) => {
                            return (
                                <FormControlLabel
                                    control={<Checkbox
                                        checked={this.state.actions[index].tasks.ticketActionTasks[j].taskStatus}
                                        onChange={(e) => this.handleActionTaskUpdate(e, index, j)}
                                        name={task.ticketActionTaskName}
                                    />}
                                    label={task.ticketActionTaskName}
                                />
                            )
                        })

                        }
                    </FormGroup>
                </FormControl>
            </div>

        );

    }

    validate = () => {
        // also go through all entries and validate if good !!!!!!!!
        let keys = Array.from(Object.keys(this.state));
        for (let i = 0; i < keys.length; i++) {
            if (keys[i] in this.state.whitelist)
                continue


            if (this.state.ticketIssueName !== "Wrong Item Sent" && this.state.ticketIssueName !== "Wrong Quantity Sent") {
                if (keys[i] in this.state.requiredListWrongItemSent) {
                    continue
                }
            }


            if (this.state.ticketIssueName !== "Wrong Item Ordered" && keys[i] in this.state.requiredListWrongItemOrdered) {
                continue
            }

            if (!this.state[keys[i]] || this.state[keys[i]].length === 0) {
                return false

            }
        }
        return !(this.state.dueDate == null || this.state.dueDate === 'Invalid Date');
    }

    handleAssignedToChange = (value) => {
        this.setState({
            assignedToId: value.userId,
            assignedToName: value.name
        })
    }

    handleFileAdd = (action, index, file) => {
        const { actions } = this.state
        //let prevActions = this.state.actions
        let prevFiles = actions[index].files
        let prevNewFiles = actions[index].newFiles ? actions[index].newFiles : []
        let prevFilesCopy = prevFiles
        let addedFile = this.getFormattedFileObject(action, file)
        actions[index].files = [addedFile]
        actions[index].newFiles = [addedFile]
        actions[index].prevFilesCopy = prevFilesCopy
        this.setState({
            actions: actions
        })
    }

    handleFileDelete = (action, index, fileIndex, file) => {

        const { actions } = this.state

        if(actions[index].isLabelAutoGenerated){
            //open dialog for two-steps confirmation
            if(this.state.actions[index]?.returnTrackingId && this.state.actions[index].actionName === "Send Return Label"){
                this.handleDialogOpen(action,index,fileIndex,file, "return")
            }
            /*else{
                this.handleOpen(action,index,fileIndex,file, "redirect")
            }*/

        }else{
            // simple remove file
            let prevFiles = actions[index].files;
            const prevDeletedFiles = actions[index].deletedFiles || [];
            const prevNewFiles = actions[index].newFiles || [];

            const deletedFile = prevFiles.splice(fileIndex, 1)[0];

            // If the deleted file exists in prevNewFiles, remove it from that list
            const newFileIndex = prevNewFiles.findIndex(f => f === deletedFile);
            if (newFileIndex !== -1) {
                prevNewFiles.splice(newFileIndex, 1);  // remove from newFiles
            } else {
                // otherwise, it's a server-side file — mark for backend deletion
                prevDeletedFiles.push(deletedFile);
            }

            // if the file had been rendered
            if ("localURL" in file) {
                this.freeFromMemory(file.localURL)
            }

            actions[index].files = prevFiles
            actions[index].newFiles = prevNewFiles
            actions[index].deletedFiles = prevDeletedFiles

            this.setState({
                actions: actions
            })
        }
    }

    freeFromMemory = (url) => {
        URL.revokeObjectURL(url)
    }

    getFormattedGeneralFileObject = (file) => {
        return { localURL: URL.createObjectURL(file), displayName: file.name, byteArray: getByteArray(file), type: file.type }

    }
    getFormattedFileObject = (action, file) => {
        return { localURL: URL.createObjectURL(file), displayName: file.name, byteArray: getByteArray(file), actionName: action.actionName, type: file.type }
    }

    getDeliveryIcon = (shipmentStatus) => {
        switch (shipmentStatus) {
            case 'Scanned':
            case 'Packed':
          //Scanned and packed have the same icon has printed
            case 'Printed':
                return <img src={Label_printedIcon} className='shipmentStatusTicket' />
            case 'Picked Up':
                return <img src={PickedIcon}className='shipmentStatusTicket' />
            case 'In Transit':
                return <img src={InTransitIcon} className='shipmentStatusTicket' />
            case 'Out For Delivery':
                return <img src={InTransitIcon} className='shipmentStatusTicket' />
            case 'On The Way':
                return <img src={InTransitIcon} className='shipmentStatusTicket' />
            case 'Delivered':
                return <img src={DeliveredIcon} className='shipmentStatusTicket' />
            case 'Exception':
                return <img src={ExceptionIcon} className='shipmentStatusTicket' />
            default:
                return <img src={UnshippedIcon} className='shipmentStatusTicket' />
        }
    }

    getDeliveryStatus = (shipmentStatus) => {
        return (
          <div style={{ marginTop: '16px', justifyContent:'left', textAlign: 'center',paddingLeft: '40px' , width: '230px'}}>
              {this.getDeliveryIcon(shipmentStatus)}
              {!shipmentStatus ?
                <div style={{ textAlign: 'center', justifyContent: 'center', color: '#005E73' }}>{"Pending"}</div>
                : <div style={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    color: '#005E73'
                }}>{shipmentStatus}</div>
              }
          </div>
        )
    }

    allowAutoGenerateReturnLabel = (action, index) =>{
        if(!this.state.orderId){
            return false
        }
        if(action.isLabelAutoGenerated){
            return false
        }
        if (action.actionName !== "Send Return Label" && action.actionName !== "Send Redirect Label"){
            return false
        }
        if (action.files && action.files?.length !== 0) {
            return false
        }
        if(this.state.ticketIssueName === "Wrong Item Ordered"){
            if(!this.state.wrongShortcodeOrdered){
                return false
            }
            if(!this.state.wrongQuantityOrdered){
                return false
            }
        }
        return true
    }

    autoGenerateReturnLabel = (action, index)=>{
        const { actions } = this.state
        actions[index].isLabelAutoGenerated = true
        this.setState({
            actions: actions
        })
        if (action.actionName === "Send Return Label") {
            this.props.generateReturnRedirect({ orderId: this.state.orderId, case: "Send Return Label",
                ticketIssueName: this.state.ticketIssueName,
                shortcodeAndQty: "(" + this.state.wrongShortcodeOrdered +")-" + this.state.wrongQuantityOrdered,
                actionIndex: index }, (data)=> {
                if(!data?.success){
                    actions[index].isLabelAutoGenerated = false
                    this.setState({
                        actions: actions
                    })
                }else{
                    this.setState({pdfFile:data?.pdfByte })
                }
            })
        }
        /*else if (action.actionName === "Send Redirect Label" ){
            this.props.generateReturnRedirect({ orderId: this.state.orderId, case: "Send Redirect Label",
                reference3: "(" + this.state.wrongShortcodeOrdered +")-" + this.state.wrongQuantityOrdered,
                shortcodeAndQty: "(" + this.state.wrongShortcodeOrdered +")-" + this.state.wrongQuantityOrdered,
                location: this.state.location.name,
                actionIndex: index }, (data)=> {
                if(!data?.success){
                    actions[index].isLabelAutoGenerated = false
                    this.setState({
                        actions: actions
                    })
                }else{
                    this.setState({pdfFile:data?.pdfByte })
                }
            })
        }*/
    }


    handleFileDownload = (file) => {

        if(this.state.pdfFile && this.state.pdfFile.length > 0){
            let blob = new Blob([Uint8Array.from(this.state.pdfFile)], { type: "application/pdf" });
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = file[0] ? file[0]?.displayName : "file"
            link.click();
            // now clear it from memory
            window.URL.revokeObjectURL(link.href)

        }else{
            const data = {
                path: file[0].path,
                ticketId: this.props.ticket.ticketId,
                actionIndex: 0,
            }

            this.props.fetchFilePreview(data,(pdfData)=>{
                let blob = new Blob([Uint8Array.from(pdfData)], { type: "application/pdf" });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = file[0] ? file[0]?.displayName : "file"
                link.click();
                // now clear it from memory
                window.URL.revokeObjectURL(link.href)
            })
        }

    }

    // TODO need to delete all the blobs from memory after save is pressed
    getActionFields = (action, index) => {
        switch (action.actionName) {
          case 'Send Replacement Package':
            return (
              <>
                <TextField
                  required
                  className="ticket-text-field"
                  variant="outlined"
                  name="replacementTrackingId"
                  value={this.state.actions[index].replacementTrackingId}
                  onChange={(e) => this.handleActionValueChange(e, index)}
                  label="Replacement Tracking ID"
                  InputLabelProps={{ shrink: true }}
                />
                {this.getTaskFields(action, index)}
              </>
            );
            case 'Issue Refund':
                return (
                    <div>
                        <div className="refund-section">
                            <Button
                                disabled={!this.allowRefundCalculation()}
                                style={{ height: '56px' }}
                                className="ticket-text-field"
                                variant="contained"
                                color="primary"
                                onClick={this.handlePopupOpen}
                            >
                                Calculate Refund
                            </Button>

                            {this.state.showPopper && (

                                <Popper
                                    open={this.state.showPopper}
                                    anchorEl={this.state.anchorEl}
                                    placement="bottom-start"
                                    style={{ zIndex: 1300 }}
                                >
                                    <RefundPopper
                                        refundType={this.state.actions[index]?.refundType}
                                        handleRefundTypeChange={this.handleRefundTypeChange(action, index)}
                                        handleClosePopper={this.handlePopupClose}
                                        options={this.getRefundOption()}
                                    />
                                </Popper>
                            )}

                            <TextField
                                required
                                className="ticket-text-field"
                                variant="outlined"
                                name="refundAmount"
                                value={this.state.actions[index].refundAmount}
                                onChange={(e) => this.handleActionValueChange(e, index)}
                                label={REFUND_AMOUNT_CHECKBOX}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <AttachMoneyIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>

                        <div className="file-upload-return">
                            <div className="ticket-text-field" />
                            {this.getTaskFields(action, index)}
                        </div>
                        {action.refundDetails  ?
                            <div className={"refund-detail-row"}>
                                <div className="refund-amount-detail-box">
                                    {Object.keys(REFUND_DETAIL_MAP)
                                        .filter((key) =>
                                            action.refundDetails?.[key] !== null &&
                                            action.refundDetails?.[key] !== undefined
                                        )
                                        .map((key) => {
                                            const value = action.refundDetails[key];
                                            const numericValue = Number(value).toFixed(2);
                                            const displayValue = key === "salePrice" ? numericValue : `-${numericValue}`;

                                            return (
                                                <div key={key} className="refund-detail-items">
                                                    <span className="refund-label">{REFUND_DETAIL_MAP[key]}</span>
                                                    <span className="refund-value">{displayValue}</span>
                                                </div>
                                            );
                                        })}
                                    <Divider style={{ marginLeft: '16px', marginRight: '16px', marginTop:'16px' }}/>
                                    <div className="refund-detail-items">
                                        <span className="refund-label">Refund Amount (before tax)</span>
                                        <span className="refund-value"> {action.refundDetails?.refundAmount != null
                                            ? Number(action.refundDetails.refundAmount).toFixed(2)
                                            : ""}</span>
                                    </div>
                                </div>
                                <div className="refund-detail-box">
                                    {Object.keys(REFUND_DETAIL_TAX_MAP)
                                        .filter((key) =>
                                            action.refundDetails?.[key] !== null &&
                                            action.refundDetails?.[key] !== undefined
                                        )
                                        .map((key) => {
                                            const value = action.refundDetails[key];
                                            const numericValue = Number(value).toFixed(2);
                                            const displayValue = key === "saleTax" ? numericValue : `-${numericValue}`;

                                            return (
                                                <div key={key} className="refund-detail-items">
                                                    <span className="refund-label">{REFUND_DETAIL_TAX_MAP[key]}</span>
                                                    <span className="refund-value">{displayValue}</span>
                                                </div>
                                            );
                                        })}
                                    <Divider style={{ marginLeft: '16px', marginRight: '16px', marginTop:'16px' }}/>
                                    <div className="refund-detail-items">
                                        <span className="refund-label">Refund Tax
                                        <Tooltip title= {"Refund tax is rounded to 2 decimal places"}>
                                                <InfoIcon  style={{ marginLeft:'5px', marginBottom:'3px', fontSize: 'medium', color: 'gray' }} />
                                            </Tooltip>
                                        </span>
                                        <span className="refund-value"> {action.refundDetails?.refundTax != null
                                            ? Number(action.refundDetails?.refundTax).toFixed(2)
                                            : ""}</span>
                                    </div>
                                </div>
                            </div>
                            : null
                        }
                    </div>
                );

          case 'File Claim':
            return (
              <>
                <TextField
                  required
                  className="ticket-text-field"
                  variant="outlined"
                  name="claimCaseId"
                  value={this.state.actions[index].claimCaseId}
                  onChange={(e) => this.handleActionValueChange(e, index)}
                  label="Claim Case ID"
                  InputLabelProps={{ shrink: true }}
                />
                {this.getTaskFields(action, index)}
              </>
            );

          case 'Investigate Lost Item':
            return (
              <>
                <TextField
                  required
                  className="ticket-text-field"
                  variant="outlined"
                  name="lostItemCaseId"
                  value={this.state.actions[index].lostItemCaseId}
                  onChange={(e) => this.handleActionValueChange(e, index)}
                  label="Case ID"
                  InputLabelProps={{ shrink: true }}
                />
                {this.getTaskFields(action, index)}
              </>
            );

          case 'Close Case':
            return (
              <>
                <TextField
                  required
                  className="ticket-text-field"
                  variant="outlined"
                  name="newOrderId"
                  value={this.state.actions[index].newOrderId}
                  onChange={(e) => this.handleActionValueChange(e, index)}
                  label="New Order ID"
                  InputLabelProps={{ shrink: true }}
                />
                {this.getTaskFields(action, index)}
              </>
            );

          case 'Send Redirect Label':
            return (
              <div>
                  <div className="file-upload-return">

                     {/* {this.state.ticketIssueName !=="Wrong Item Sent" && this.state.ticketIssueName !== "Wrong Quantity Sent" &&
                        <Tooltip title="Auto-generate redirect label">
                            <IconButton
                                onClick={() => this.autoGenerateReturnLabel(action, index)}
                                disabled={!this.allowAutoGenerateReturnLabel(action, index)}
                            >
                                <PictureAsPdfIcon
                                  variant="outlined"
                                  style={{ color: this.allowAutoGenerateReturnLabel(action, index)? green[500]: 'gray' }}
                                />
                            </IconButton>
                        </Tooltip>
                      }*/}

                      <div style={{ width: '100%',
                          marginLeft: '12px'
                      }}>
                          <FileUpload
                            handleFileAdd={(file) =>
                              this.handleFileAdd(action, index, file)
                            }
                            handleFileDelete={(file, fileIndex) =>
                              this.handleFileDelete(action, index, fileIndex, file)
                            }
                            files={action.files ? action.files : []}
                            fetchFilePreview={(file) =>
                              this.props.fetchFilePreview({
                                  path: file.path,
                                  ticketId: this.props.ticket.ticketId,
                                  actionIndex: index,
                              })
                            }
                            singleFileUpload={true}
                            type={'ticket'}
                          />
                      </div>
                    {/*  {(action.files?.[0]?.path || (this.state.pdfFile && this.state.pdfFile.length > 0)) && (
                        <Tooltip title="Download">
                            <IconButton onClick={() => this.handleFileDownload(action.files)}>
                                <DownloadIcon
                                  variant="outlined"
                                  style={{ color: this.allowAutoGenerateReturnLabel(action, index)? green[500]: 'gray' }}
                                />
                            </IconButton>
                        </Tooltip>
                      )}
*/}
                  </div>

                        <div style={{
                            margin: 0,
                            paddingLeft: '0'
                        }}>

                            <TextField
                              className="ticket-text-field"
                              variant="outlined"
                              name="redirectLabelId"
                              value={this.state.actions[index].redirectLabelId}
                              onChange={(e) => this.handleActionValueChange(e, index)}
                              onBlur={(e) => this.handleReturnTrackingNumberBlur(e, index)}
                              label="Redirect Tracking ID"
                              InputLabelProps={{ shrink: true }}
                            />

                            <TextField
                                style={{
                                    margin: '10px',
                                    width: '130px'
                                }}
                              variant="outlined"
                              name="returnRate"
                              value={
                                  this.props.trackingStatusAndRate &&
                                  this.props.trackingStatusAndRate[index]?.rate &&
                                  this.state.actions[index]?.redirectLabelId
                                      ? this.props.trackingStatusAndRate[index]?.rate
                                      : ""
                              }
                              onChange={(e) => this.handleActionValueChange(e, index)}
                              label="Rate"
                              disabled={true}
                              InputLabelProps={{ shrink: true }}
                            />

                            <TextField
                                style={{
                                    margin: '10px',
                                    width: '125px'
                                }}
                                variant="outlined"
                                name="returnRate"
                                value={
                                    this.props.trackingStatusAndRate &&
                                    this.props.trackingStatusAndRate[index]?.rateCurrency &&
                                    this.state.actions[index]?.redirectLabelId
                                        ? this.props.trackingStatusAndRate[index]?.rateCurrency
                                        : ""
                                }
                                onChange={(e) => this.handleActionValueChange(e, index)}
                                label="Currency"
                                disabled={true}
                                InputLabelProps={{ shrink: true }}
                            />
                        </div>

                  <div className="ticket-tracking">
                      {this.props.trackingStatusAndRate && this.props.trackingStatusAndRate[index]?.shipmentStatus && this.state.actions[index].redirectLabelId &&
                        this.getDeliveryStatus(this.props.trackingStatusAndRate[index]?.shipmentStatus)}

                      {this.getTaskFields(action, index)}
                  </div>

              </div>
            );

            case 'Send Return Label':
                return (
                  <div>
                      <div className="file-upload-return">

                          {this.state.ticketIssueName !=="Wrong Item Sent" && this.state.ticketIssueName !== "Wrong Quantity Sent" &&
                          <Tooltip title="Auto-generate return label">
                              <IconButton
                                  onClick={() => this.autoGenerateReturnLabel(action, index)}
                                  disabled={!this.allowAutoGenerateReturnLabel(action, index)}
                              >
                                  <PictureAsPdfIcon
                                    variant="outlined"
                                    style={{ color: this.allowAutoGenerateReturnLabel(action, index)? green[500]: 'gray' }}
                                  />
                              </IconButton>
                          </Tooltip>
                          }

                          <div style={{ width: '100%',
                              marginLeft: this.state.ticketIssueName === "Wrong Item Sent" || this.state.ticketIssueName === "Wrong Quantity Sent" ? '12px' : '0px'
                          }}>
                              <FileUpload
                                handleFileAdd={(file) =>
                                  this.handleFileAdd(action, index, file)
                                }
                                handleFileDelete={(file, fileIndex) =>
                                  this.handleFileDelete(action, index, fileIndex, file)
                                }
                                files={action.files}
                                fetchFilePreview={(file) =>
                                  this.props.fetchFilePreview({
                                      path: file.path,
                                      ticketId: this.props.ticket.ticketId,
                                      actionIndex: index,
                                  })
                                }
                                type={'ticket'}
                                singleFileUpload={true}
                              />
                          </div>

                          {(action.files?.[0]?.path || (this.state.pdfFile && this.state.pdfFile.length > 0)) && !this.allowAutoGenerateReturnLabel(action, index) && action.isLabelAutoGenerated && (
                            <Tooltip title="Download">
                                <IconButton onClick={() => this.handleFileDownload(action.files)}>
                                    <DownloadIcon
                                      variant="outlined"
                                      style={{ color: !this.allowAutoGenerateReturnLabel(action, index)? green[500]: 'gray' }}
                                    />
                                </IconButton>
                            </Tooltip>
                          )}
                      </div>

                        <div style={{
                            margin: 0,
                            paddingLeft: this.state.ticketIssueName === "Wrong Item Sent" || this.state.ticketIssueName === "Wrong Quantity Sent" ? '0' : '46px'
                        }}>
                            <TextField
                              className="ticket-custom-field"
                              variant="outlined"
                              name="returnTrackingId"
                              value={this.state.actions[index].returnTrackingId}
                              onChange={(e) => this.handleActionValueChange(e, index)}
                              onBlur={(e) => this.handleReturnTrackingNumberBlur(e, index)}
                              label="Return Tracking ID"
                              disabled={this.state.actions[index].isLabelAutoGenerated}
                              InputLabelProps={{ shrink: true }}
                            />

                            <TextField
                              style={{
                                  margin: '10px',
                                  width: this.state.ticketIssueName === "Wrong Item Sent" || this.state.ticketIssueName === "Wrong Quantity Sent" ? '128px' :'105px'
                              }}
                              variant="outlined"
                              name="returnRate"
                              value={
                                  this.props.trackingStatusAndRate &&
                                  this.props.trackingStatusAndRate[index]?.rate &&
                                  this.state.actions[index]?.returnTrackingId
                                      ? this.props.trackingStatusAndRate[index].rate
                                      : ""
                              }
                              onChange={(e) => this.handleActionValueChange(e, index)}
                              label="Rate"
                              disabled={true}
                              InputLabelProps={{ shrink: true }}
                            />
                            <TextField
                                style={{
                                    margin: '10px',
                                    width:  this.state.ticketIssueName === "Wrong Item Sent" || this.state.ticketIssueName === "Wrong Quantity Sent" ? '128px' : '105px'
                                }}
                                variant="outlined"
                                name="returnRate"
                                value={
                                    this.props.trackingStatusAndRate &&
                                    this.props.trackingStatusAndRate[index]?.rateCurrency &&
                                    this.state.actions[index]?.returnTrackingId
                                        ? this.props.trackingStatusAndRate[index].rateCurrency
                                        : ""
                                }
                                onChange={(e) => this.handleActionValueChange(e, index)}
                                label="Currency"
                                disabled={true}
                                InputLabelProps={{ shrink: true }}
                            />
                        </div>

                      <div className="ticket-tracking">
                          {this.props.trackingStatusAndRate && this.props.trackingStatusAndRate[index]?.shipmentStatus && this.state.actions[index].returnTrackingId &&
                            this.getDeliveryStatus(this.props.trackingStatusAndRate[index].shipmentStatus)}

                          {this.getTaskFields(action, index)}
                      </div>
                  </div>
                );
            case 'Resolved - Non Issue':
            case 'Customer - No Response':
                return <>{this.getTaskFields(action, index)}</>;
            case 'Send Pending Shipment':
                return (
                  <>
                      <TextField
                        required
                        className="ticket-text-field"
                  variant="outlined"
                  name="trackingId"
                  value={this.state.actions[index].trackingId}
                  onChange={(e) => this.handleActionValueChange(e, index)}
                  label="Tracking ID"
                  InputLabelProps={{ shrink: true }}
                />
                {this.getTaskFields(action, index)}
              </>
            );

          case 'Open a Case':
            return (
              <>
                <TextField
                  required
                  className="ticket-text-field"
                  variant="outlined"
                  name="caseId"
                  value={this.state.actions[index].caseId}
                  onChange={(e) => this.handleActionValueChange(e, index)}
                  label="Case ID"
                  InputLabelProps={{ shrink: true }}
                />
                {this.getTaskFields(action, index)}
              </>
            );

          case 'Credit Received':
            return (
              <>
                <TextField
                  required
                  className="ticket-text-field"
                  variant="outlined"
                  name="creditReceived"
                  value={this.state.actions[index].creditReceived}
                  onChange={(e) => this.handleActionValueChange(e, index)}
                  label="Credit Received"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AttachMoneyIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                {this.getTaskFields(action, index)}
              </>
            );

          case 'Respond to A-to-Z Claim':
            return <>{this.getTaskFields(action, index)}</>;

          case 'Respond to Chargeback Claim':
            return <>{this.getTaskFields(action, index)}</>;
          // newly added action row
          default:
            return <></>;
        }
    }


    cancel = () => {
        if (this.state.actions.length !== 0) {
            this.state.actions.forEach((action) => {
                if (action.files) {
                    action.files.forEach((file) => {
                        if ("localURL" in file)
                            this.freeFromMemory(file.localURL)
                    })
                }
            })
        }
        this.props.cancel()
    }

    handleGeneralFileAdd = (file) => {
        const { files, newFiles } = this.state
        //let prevNewFiles = this.state.newFiles
        //let prevFiles = this.state.files
        let newFile = this.getFormattedGeneralFileObject(file)


        files.push(newFile)
        newFiles.push(newFile)

        this.setState({
            newFiles: newFiles,
            files: files
        });
    }

    handleGeneralFileDelete = (file, index) => {
        const { files, newFiles, deletedFiles } = this.state
        /*let prevFiles = this.state.files
        let deletedFiles = this.state.deletedFiles
        let prevNewFiles = this.state.newFiles*/

        let deletedFile = (files.splice(index, 1))[0]
        if (!("byteArray" in file)) {
            deletedFiles.push(deletedFile)
        }
        else {
            newFiles.splice(index, 1)
        }
        if ("localURL" in file) {
            this.freeFromMemory(file.localURL)
        }

        this.setState({
            files: files,
            deletedFiles: deletedFiles,
            newFiles: newFiles
        })
    }

    handleDialogOpen = (action,index,fileIndex,file, type) => {
        this.setState({ action,index,fileIndex,file,type, isDialogOpen: true });
    };

    handleClose = () => {
        this.setState({ action: null,  index: null,  fileIndex: null,  file: null,  type: null, isDialogOpen: false });
    };

    handleBackOpen = () => {
        if (this.compareStateWithBaseState()) {
            this.setState({ isBackDialogOpen: true });
        } else {
            this.props.setBack();
        }
    };

    handleBackClose = () => {
        this.props.setBack()
        this.setState({ isBackDialogOpen: false })
    };
    handleSave = () =>{
        this.props.submit(this.state, this.props.creatingTicket)
    }

    compareStateWithBaseState() {
        const { whitelist, actions } = this.state;

        if (!_.isEqual(this.baseActions, actions)) {
            return true;
        }

        for (const key in this.baseState) {
            if (!whitelist[key] && this.baseState[key] !== this.state[key]){
                return true;
            }
        }
        return false; // No changes detected
    }


    handleDelete = (actionType) => {
        const {actions,index,fileIndex,file, type } = this.state;

        if(actionType === 'Yes'){
            if(type === 'return'){
                // type === 'return'
                this.props.deleteReturnRedirect(
                    { trackingId: this.state.actions[index]?.returnTrackingId },
                    (error, data) => {
                        if (data?.success) {
                            let prevFiles = actions[index].files
                            const prevDeletedFiles = actions[index].deletedFiles || [];
                            const prevNewFiles = actions[index].newFiles || [];

                            // we need to see if the deleted file is in the newFiles or if it is a file from the server
                            const deletedFile = prevFiles.splice(fileIndex, 1)[0];
                            // remote file that already exists on the server
                            const newFileIndex = prevNewFiles.findIndex(f => f === deletedFile);
                            if (newFileIndex !== -1) {
                                prevNewFiles.splice(newFileIndex, 1);  // remove from newFiles
                            } else {
                                // otherwise, it's a server-side file — mark for backend deletion
                                prevDeletedFiles.push(deletedFile);
                            }

                            // if the file had been rendered
                            if ("localURL" in file) {
                                this.freeFromMemory(file.localURL)
                            }

                            actions[index].files = prevFiles
                            actions[index].newFiles = prevNewFiles
                            actions[index].deletedFiles = prevDeletedFiles

                            this.setState({
                                actions: actions
                            })

                            this.setState((prevState) => {
                                this.props.clearReturnRedirectTrackingNumber(index)
                                const updatedActions = [...prevState.actions];
                                updatedActions[index] = {
                                    ...updatedActions[index],
                                    returnTrackingId: "",
                                    returnRate: "",
                                    returnRateCurrency: "",
                                    isLabelAutoGenerated:false
                                };
                                return { actions: updatedActions };
                            });
                        }
                    }
                )
            }
           /* else{
                this.props.deleteReturnRedirect(
                  { trackingId: this.state.actions[index]?.redirectLabelId },
                  (error, data) => {
                      if (data?.success) {
                          let prevFiles = actions[index].files
                          const prevDeletedFiles = actions[index].deletedFiles || [];
                          const prevNewFiles = actions[index].newFiles || [];

                          // we need to see if the deleted file is in the newFiles or if it is a file from the server
                          const deletedFile = prevFiles.splice(fileIndex, 1)[0];
                          // remote file that already exists on the server
                          const newFileIndex = prevNewFiles.findIndex(f => f === deletedFile);
                          if (newFileIndex !== -1) {
                              prevNewFiles.splice(newFileIndex, 1);  // remove from newFiles
                          } else {
                              // otherwise, it's a server-side file — mark for backend deletion
                              prevDeletedFiles.push(deletedFile);
                          }

                          // if the file had been rendered
                          if ("localURL" in file) {
                              this.freeFromMemory(file.localURL)
                          }

                          actions[index].files = prevFiles
                          actions[index].newFiles = prevNewFiles
                          actions[index].deletedFiles = prevDeletedFiles

                          this.setState({
                              actions: actions
                          })

                          this.setState((prevState) => {
                              this.props.clearReturnRedirectTrackingNumber(index)
                              const updatedActions = [...prevState.actions];
                              updatedActions[index] = {
                                  ...updatedActions[index],
                                  redirectLabelId: "",
                                  returnRate: "",
                                  returnRateCurrency: "",
                                  isLabelAutoGenerated:false
                              };
                              return { actions: updatedActions };
                          });
                      }
                  }
                )
            }*/
        }
        this.handleClose()
    };

    render() {
        return (
          <>

              {!this.props.creatingTicket &&
                <TopToolbar
                  pageName={TICKETS_TOOLBAR_TITLE}
                  menuItems={[
                      {title: BACK_TO_MENU, icon: <KeyboardBackspaceIcon/>,
                          onClick: () => { this.handleBackOpen()}
                      }
                  ]}
                />
              }

              <Dialog open={this.state.isDialogOpen} onClose={this.handleClose}>
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent>
                      <DialogContentText>
                          Remove the attachment will also void the label and delete return shipment. Do you want to proceed?
                      </DialogContentText>
                  </DialogContent>
                  <DialogActions>

                      <div className='save-cancel-buttons' style={{marginRight:'16px'}}>
                          <Button
                            variant='contained'
                            color='primary'
                            onClick={()=> this.handleDelete("Yes")}
                          >
                              YES
                          </Button>

                          <div className='save-spacing'/>
                          <Button
                            variant='contained'
                            onClick={this.handleClose}
                          >
                              No
                          </Button>
                      </div>

                  </DialogActions>
              </Dialog>

              <Dialog open={this.state.isBackDialogOpen} onClose={this.handleBackClose}>
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent>
                      <DialogContentText>
                          Would you like to save your changes?
                      </DialogContentText>
                  </DialogContent>
                  <DialogActions>

                      <div className='save-cancel-buttons' style={{marginRight:'16px'}}>
                          <Button
                            variant='contained'
                            color='primary'
                            onClick={()=> this.handleSave()}
                          >
                              YES
                          </Button>


                          <div className='save-spacing'/>
                          <Button
                            variant='contained'
                            onClick={this.handleBackClose}
                          >
                              No
                          </Button>
                      </div>

                  </DialogActions>
              </Dialog>

            <div className='ticket-box'>
                <div className='ticket-form-input-box'>
                    <div>
                        <div className='ticket-row-flexbox'>
                            <div className='row-empty-box'></div>
                            <Autocomplete
                                options={this.props.locations}
                                getOptionLabel={(option) => option?.name}
                                autoHighlight={true}
                                className='ticket-text-field'
                                onChange={(event, value) => { this.handleLocationChange(value) }}
                                value={this.state.location}
                                name="location"
                                blurOnSelect={true}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label="Location"
                                        InputLabelProps={{ shrink: true }}
                                        variant="outlined"
                                        name="location"
                                        required
                                    />
                                }
                            />
                            {this.state.isMPS &&
                                <Chip
                                    variant="outlined"
                                    size="small"
                                    style={{
                                        borderRadius: "10px",
                                        border: "2px solid #acd685",
                                        padding: '0px 8px',
                                        marginTop: '20px',
                                        marginLeft: '16px',
                                        fontSize: "12px"
                                    }}
                                    label="MPS"
                                />
                            }
                        </div>
                        <div className='ticket-row-flexbox'>
                            <div className='row-empty-box'></div>
                            <Autocomplete
                                options={this.props.ticketIssues}
                                getOptionLabel={(ticketIssues) => ticketIssues.ticketIssueName}
                                autoHighlight={true}
                                className='ticket-text-field'
                                onChange={(event, value) => { this.handleIssueChange(value) }}
                                value={{ ticketIssueId: this.state.ticketIssueId, ticketIssueName: this.state.ticketIssueName }}
                                name="issue"
                                disableClearable
                                blurOnSelect={true}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label="Issue"
                                        InputLabelProps={{ shrink: true }}
                                        variant="outlined"
                                        name="issueType"
                                        required
                                    />
                                }
                            />
                            <TextField
                                required
                                className='ticket-text-field'
                                variant="outlined"
                                name="orderId"
                                value={this.state.orderId}
                                onChange={this.handleChange}
                                onBlur={this.handleOrderIdChange}
                                label="Order ID"
                                InputLabelProps={{ shrink: true }}
                            />
                            <TextField
                                required
                                className='ticket-text-field'
                                variant="outlined"
                                name="originalTrackingId"
                                value={this.state.originalTrackingId}
                                onChange={this.handleChange}
                                onBlur={this.handleOriginalTrackingIdChange}
                                label="Original Tracking ID"
                                InputLabelProps={{ shrink: true }}
                            />
                        </div>

                        <div className='ticket-row-flexbox'>
                            <div className='row-empty-box' />
                            <TextField
                                required
                                className='ticket-text-field'
                                variant="outlined"
                                name="customerName"
                                value={this.state.customerName}
                                onChange={this.handleChange}
                                label="Customer Name"
                                InputLabelProps={{ shrink: true }}
                            />

                            {this.state.ticketIssueName !== "Wrong Item Sent" &&
                            this.state.ticketIssueName !== "Wrong Item Ordered" &&
                            this.state.ticketIssueName !== "Wrong Quantity Sent"?
                                <>
                                    <div className='empty-box' />
                                    <div className='empty-box' />
                                </>
                                :
                                this.state.ticketIssueName === "Wrong Item Sent" ||  this.state.ticketIssueName === "Wrong Quantity Sent"?
                                    <>
                                        <Autocomplete
                                            options={this.props.products ? this.props.products.map(product => product.shortcode).sort((a, b) => { return a.toLowerCase().localeCompare(b.toLowerCase()) }) : []}
                                            getOptionLabel={(product) => product}
                                            autoHighlight={true}
                                            className='ticket-text-field'
                                            onChange={(event, value) => { this.handleAutocompleteChange(value, "wrongShortcodeSent", -1) }}
                                            value={this.state.wrongShortcodeSent}
                                            name="wrongShortcodeSent"
                                            blurOnSelect={true}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    label={WRONG_ITEM_SENT_SHORTCODE_LABEL}
                                                    InputLabelProps={{shrink: true}}
                                                    variant="outlined"
                                                    required
                                                />
                                            }
                                        />
                                        <TextField
                                            required
                                            className='ticket-text-field'
                                            variant="outlined"
                                            name="wrongQuantitySent"
                                            value={this.state.wrongQuantitySent}
                                            onChange={this.handleChange}
                                            label={WRONG_ITEM_SENT_QUANTITY_LABEL}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </>
                                    :
                                    <>
                                        <Autocomplete
                                            options={this.props.products ? this.props.products.map(product => product.shortcode).sort((a, b) => { return a.toLowerCase().localeCompare(b.toLowerCase()) }) : []}
                                            getOptionLabel={(product) => product}
                                            autoHighlight={true}
                                            className='ticket-text-field'
                                            onChange={(event, value) => { this.handleAutocompleteChange(value, "wrongShortcodeOrdered", -1) }}
                                            value={this.state.wrongShortcodeOrdered}
                                            name="wrongShortcodeOrdered"
                                            blurOnSelect={true}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    label={WRONG_ITEM_ORDERED_SHORTCODE_LABEL}
                                                    InputLabelProps={{shrink: true}}
                                                    variant="outlined"
                                                    required
                                                />
                                            }
                                        />
                                        <TextField
                                            required
                                            className='ticket-text-field'
                                            variant="outlined"
                                            name="wrongQuantityOrdered"
                                            value={this.state.wrongQuantityOrdered}
                                            onChange={this.handleChange}
                                            label={WRONG_ITEM_ORDERED_QUANTITY_LABEL}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <Divider className='section-divider' />

                {/*This is the action adding autocomplete field*/}
                <div className='ticket-form-input-box'>
                    <div>
                        {!this.props.creatingTicket ?
                            <>
                                {/*dynamically generated list of autocompletes*/}
                                {this.state.actions.map((action, index) => {
                                    return (
                                        <>
                                            <div className='ticket-row-flexbox '>
                                                {/*<Divider className={'action-divider'}/>*/}
                                                {!(this.props.ticket && (this.props.ticket.status === COMPLETED_STATUS)) ?
                                                    <div className='remove-icon'>
                                                        <IconButton onClick={() => this.removeAction(index)}>
                                                            <RemoveCircleIcon
                                                                color="error"
                                                                style={{ color: "red" }}
                                                            />
                                                        </IconButton>
                                                    </div>
                                                    :
                                                    <div className='row-empty-box' />
                                                }
                                                <Autocomplete
                                                    options={this.props.ticketActions}
                                                    value={{ ticketActionId: action.actionId, ticketActionName: action.actionName }}
                                                    getOptionLabel={(ticketAction) => ticketAction.ticketActionName}
                                                    autoHighlight={true}
                                                    className='ticket-text-field'
                                                    disableClearable
                                                    name="actionName"
                                                    shrink
                                                    blurOnSelect={true}
                                                    onChange={(event, value) => { this.handleActionChange(value, index) }}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            label={ACTION_LABEL}
                                                            InputLabelProps={{ shrink: true }}
                                                            variant="outlined"
                                                            name="actionType"
                                                            required
                                                        />
                                                    }
                                                />
                                                {this.getActionFields(action, index)}
                                            </div>
                                            <Divider className='sub-section-divider' />
                                        </>
                                    )
                                })}

                                <div className='ticket-row-flexbox'>
                                    <div className='row-empty-box' />
                                    <div className='ticket-text-field'>
                                        {!(this.props.ticket && (this.props.ticket.status === COMPLETED_STATUS)) ?
                                            <Tooltip placement="bottom" title={ADD_ACTION}>
                                                <Button className='add-action-button' variant="contained" color="primary" onClick={this.addAction}>
                                                    {ADD_ACTION_BUTTON_TEXT}
                                                </Button>
                                            </Tooltip>
                                            :
                                            null
                                        }

                                    </div>
                                    <div className='ticket-text-field'></div>
                                    <div className='ticket-text-field'></div>
                                </div>
                            </>
                            :
                            <>
                                <div className='buttons'>
                                    <div className='ticket-row-flexbox'>
                                        <div className='row-empty-box' />
                                        <div className='ticket-text-field'>
                                            <Tooltip placement="left" title={ADD_ACTION}>
                                                <Button disabled className='add-action-button' variant="contained" color="primary" onClick={this.addAction}>
                                                    {ADD_ACTION_BUTTON_TEXT}
                                                </Button>
                                            </Tooltip>
                                        </div>
                                        <div className='ticket-text-field'></div>
                                        <div className='ticket-text-field'></div>
                                    </div>
                                    <Tooltip
                                        className='tooltip'
                                        enterTouchDelay={0}
                                        leaveTouchDelay={30000}
                                        enterDelay={400}
                                        // leaveDelay={1000000} // for testing purposes
                                        title={
                                            <React.Fragment>
                                                The ADD ACTION button will be enabled after the ticket is created
                                                <br />
                                            </React.Fragment>
                                        }
                                    >
                                        <IconButton aria-label='info' className='tooltip'>
                                            <InfoOutlinedIcon variant='outlined' fontSize='small' />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </>
                        }
                    </div>
                </div>

                <Divider className='section-divider' />

                <div className='ticket-form-input-box'>
                        <CommentHistoryTable
                            disabled={false}
                            comments={this.props.creatingTicket ? [] : this.props.ticket.comments}
                            handleCommentUpdate={this.handleCommentUpdate}
                            currentUser={this.props.currentUser}
                            clearComment={() => this.setState({ comments: '' })}
                            isTickets={true}
                        />
                </div>

                <Divider className='section-divider' />

                <div className='ticket-form-input-box'>
                    <div>
                        <div className='ticket-row-flexbox'>
                            <div className='row-empty-box' />
                            <div className='file-upload'>
                                <FileUpload
                                    handleFileAdd={this.handleGeneralFileAdd}
                                    handleFileDelete={this.handleGeneralFileDelete}
                                    files={this.state.files ? this.state.files : []}
                                    fetchFilePreview={(file) => this.props.fetchFilePreview({ path: file.path, ticketId: this.props.ticket.ticketId })}
                                    singleFileUpload={false}
                                />
                            </div>
                            <Autocomplete
                                options={this.props.users}
                                getOptionLabel={(user) => user.name}
                                autoHighlight={true}
                                className='ticket-text-field'
                                onChange={(event, value) => { this.handleAssignedToChange(value) }}
                                name="assignedTo"
                                value={this.props.users.find((user) => user.userId === this.state.assignedToId)}
                                blurOnSelect={true}
                                disableClearable
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label="Assigned To"
                                        InputLabelProps={{ shrink: true }}
                                        variant="outlined"
                                        name="assignedToField"
                                        required
                                    />
                                }
                            />

                            <KeyboardDatePicker
                                required
                                error={this.state.dueDate == null || this.state.dueDate == 'Invalid Date'}
                                autoOk
                                variant="inline"
                                inputVariant="outlined"
                                label="Due Date"
                                format="yyyy/MM/dd"
                                className='ticket-text-field'
                                value={this.state.dueDate}
                                InputAdornmentProps={{ position: "start" }}
                                onChange={date => this.handleDateChange(date, true)}
                            />
                        </div>

                    </div>

                    <div className='buttons'>
                        <div className='ticket-cancel-button'>
                            <Button
                                variant='contained'
                                onClick={() => {
                                    //this.setState(this.baseState);
                                    this.cancel()

                                }
                                }
                            >
                                {CANCEL}
                            </Button>
                        </div>

                        <div className='ticket-save-button'>
                            <Button
                                variant='contained'
                                disabled={!this.validate()}
                                onClick={(event) => {
                                    event.showLoadingOverlay = true  // Prevents spam clicking the button
                                    this.props.submit(this.state, this.props.creatingTicket)
                                }}
                                color='primary'
                            >
                                {SAVE}
                            </Button>
                        </div>
                    </div>

                </div>
            </div>
          </>
        );
    }
}

TicketsForm.propTypes = {
    currentUser: PropTypes.object,
    creatingTicket: PropTypes.bool,
    cancel: PropTypes.func,
    submit: PropTypes.func,
    ticket: PropTypes.object,
    ticketIssues: PropTypes.array,
    ticketActions: PropTypes.array,
    ticketActionTasks: PropTypes.object,
    users: PropTypes.array,
    requestIssueSpecificActions: PropTypes.func,
    requestIssueSpecificTasks: PropTypes.func,
    fetchFilePreview: PropTypes.func
}

TicketsForm.defaultProps = {
    currentUser: {},
    creatingTicket: false,
    cancel: () => { },
    submit: () => { },
    ticket: {},
    ticketIssues: [],
    ticketActions: [],
    ticketActionTasks: {},
    users: [],
    requestIssueSpecificActions: () => { },
    requestIssueSpecificTasks: () => { },
    fetchFilePreview: () => { }
}

export default TicketsForm;